import { render, staticRenderFns } from "./contractSettings.vue?vue&type=template&id=0203030c&scoped=true"
import script from "./contractSettings.vue?vue&type=script&lang=js"
export * from "./contractSettings.vue?vue&type=script&lang=js"
import style0 from "./contractSettings.vue?vue&type=style&index=0&id=0203030c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0203030c",
  null
  
)

export default component.exports